export default function formGroup({ variables }) {
    return {
        MuiFormGroup: {
            styleOverrides: {
                root: {
                    rowGap: variables.spacing_02,
                },
            },
        },
    };
}
//# sourceMappingURL=formGroup.js.map